export default "__VITE_ASSET__b00cb052__"